export const COMMENTS_LIST_REQUEST = 'COMMENTS_LIST_REQUEST'
export const COMMENTS_LIST_SUCCESS = 'COMMENTS_LIST_SUCCESS'
export const COMMENTS_LIST_FAILED = 'COMMENTS_LIST_FAILED'
export const COMMENTS_LIST_RESET = 'COMMENTS_LIST_RESET'

export const COMMENTS_ADMIN_LIST_REQUEST = 'COMMENTS_ADMIN_LIST_REQUEST'
export const COMMENTS_ADMIN_LIST_SUCCESS = 'COMMENTS_ADMIN_LIST_SUCCESS'
export const COMMENTS_ADMIN_LIST_FAILED = 'COMMENTS_ADMIN_LIST_FAILED'
export const COMMENTS_ADMIN_LIST_RESET = 'COMMENTS_ADMIN_LIST_RESET'